/**
 * 会员注册页：输入邮箱，发送 Resend 验证邮件
 */

import { useState } from 'react'
import { registerEmail } from '../api'

export default function Register() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [sent, setSent] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    const trimmed = email.trim()
    if (!trimmed || !trimmed.includes('@')) {
      setError('请输入有效的邮箱地址')
      return
    }
    setLoading(true)
    try {
      await registerEmail(trimmed)
      setSent(true)
    } catch (err) {
      setError(err instanceof Error ? err.message : '注册失败')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-slate-50 via-sky-50 to-indigo-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white/80 backdrop-blur-xl rounded-3xl shadow-[0_12px_40px_-12px_rgba(100,116,139,0.2)] border border-white/60 p-8">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-sky-500 to-indigo-500 text-white text-3xl mb-4 shadow-lg shadow-sky-300/40">
            ✉️
          </div>
          <h1 className="text-2xl font-bold text-slate-800">注册会员</h1>
          <p className="text-slate-500 text-sm mt-1">验证邮箱后即可设置用户名与密码</p>
        </div>

        {sent ? (
          <div className="rounded-2xl bg-emerald-50 border border-emerald-200 p-6 text-center">
            <div className="text-3xl mb-2">📬</div>
            <h2 className="text-lg font-bold text-emerald-800 mb-2">验证邮件已发送</h2>
            <p className="text-sm text-emerald-700 mb-4">
              请查收 <strong>{email}</strong> 的收件箱，点击邮件中的链接完成验证。
            </p>
            <a
              href="/"
              className="inline-block px-5 py-2 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold transition-colors"
            >
              返回首页
            </a>
          </div>
        ) : (
          <>
            {error && (
              <div className="mb-4 rounded-xl bg-rose-50 border border-rose-200 px-4 py-3 text-sm text-rose-700">
                {error}
              </div>
            )}
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1.5">邮箱</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-sky-500/30 focus:border-sky-500 text-sm transition-all"
                  placeholder="your@email.com"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-gradient-to-r from-sky-600 to-indigo-600 hover:from-sky-700 hover:to-indigo-700 disabled:opacity-60 disabled:cursor-not-allowed text-white font-bold py-3 rounded-xl text-sm shadow-lg shadow-sky-200 transition-all"
              >
                {loading ? '发送中...' : '发送验证邮件'}
              </button>
            </form>

            <div className="mt-6 text-center text-sm text-slate-500">
              已有账号？
              <a href="/login" className="text-sky-600 font-semibold hover:underline ml-1">
                直接登录
              </a>
            </div>

            <div className="mt-4 text-center">
              <a href="/" className="text-xs text-slate-400 hover:text-slate-600">
                ← 返回首页
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
